<template>
    <div class="idle-info">
        <span class="idle-info__level--yellow">Idle</span><br />
        <strong>Address:</strong> {{ idlePoint.addressLabel }}<br />
        <strong>Start:</strong> {{ formatDate(idlePoint.start) }}<br />
        <strong>End:</strong> {{ formatDate(idlePoint.end) }}<br />
        <strong>Duration:</strong> {{ duration }}<br />
    </div>
</template>

<script>
import { formatDate } from '@/helpers/Utils'
import IdlePoint from "@/models/IdlePoint";
import moment from "moment";

export default {
    name: 'IdleInfoBubble',
    props: {
        idlePoint: {
            type: [IdlePoint, Object],
            required: true
        }
    },
    computed: {
        duration: function () {
            if (!this.idlePoint.end) return 'Unknown'

            const start = moment(this.idlePoint.start)
            const end = moment(this.idlePoint.end)
            return moment.utc(moment(end, 'HH:mm:ss').diff(moment(start, 'HH:mm:ss'))).format('HH:mm:ss')
        },
    },
    methods: {
        formatDate (date) {
            return formatDate(date)
        },
    }
}
</script>

<style scoped lang="scss">
.idle-info {
    padding: 10px 20px;
    min-width: 260px;

    &__level {
        font-weight: bold;

        &--yellow {
            color: #FDBF5E;
        }
    }
}

</style>
